const CareerPathwaysBenefitsLayout = <template>{{outlet}}</template>;

export default CareerPathwaysBenefitsLayout;
